import React from "react";
import { SITE } from "../config/site";

/**
 * Minimal SEO manager that avoids extra dependencies (no react-helmet needed).
 * Updates document.title and meta tags on route change.
 */
export default function SEO({ title, description, path = "/", noindex = false }) {
  React.useEffect(() => {
    if (typeof document === "undefined") return;
    const base = SITE.siteUrl.replace(/\/$/, "");
    const url = base + path;
    const image = `${base}/og-cover.png`;
    const publicTitle = String(title || "");
    const publicDescription = String(description || "");
    document.title = publicTitle;
    setMeta("description", publicDescription);
    setMeta("robots", noindex ? "noindex,nofollow" : "index,follow");
    setMeta("theme-color", "#040608");
    setMetaProperty("og:title", publicTitle);
    setMetaProperty("og:description", publicDescription);
    setMetaProperty("og:type", "website");
    setMetaProperty("og:site_name", "Culmora OS");
    setMetaProperty("og:url", url);
    setMetaProperty("og:image", image);
    setMetaProperty("og:image:width", "1200");
    setMetaProperty("og:image:height", "630");
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", publicTitle);
    setMeta("twitter:description", publicDescription);
    setMeta("twitter:image", image);
    setCanonical(url);
  }, [title, description, path, noindex]);
  return null;
}

function setMeta(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content || "");
}

function setMetaProperty(prop, content) {
  let el = document.querySelector(`meta[property="${prop}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", prop);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content || "");
}

function setCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}
